import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import config from "../config";
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles, title} from "../website-utils/meta";
import {connect} from "react-redux";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";

import ProHeader from '../parts/ProHeader';
import Footer from '../parts/Footer';


export class ProFaqPage extends React.Component {
  componentDidMount() {
    window.analytics.page("Pros", "FAQ");
  }

  render() {
    window.prerenderReady = true;
    const {classes} = this.props;

    return (
      <div className="pro home">
        <Helmet>
          {title('SingleShift - Pro FAQ')}
          {metaTitles('SingleShift - Pro FAQ')}
          {metaDescriptions('Book online in seconds and schedule a Pro for whenever you need them in the next day or week.')}
        </Helmet>
        <ScrollToTopOnMount/>

        {/* HERO */}
        <div className={`${classes.hero} hero`}>
          <div className="container">
            <ProHeader/>
            <div className="row justify-content-md-center">
              <div className={`${classes.headline} col-md-6 headline text-center`}>
                <p className={`${classes.pageIdentifier} text-uppercase`}>Frequently Asked Questions</p>
                <h1>Questions? Meet Answers.</h1>
                <p>Have a question that isn't covered? Contact: hsuken@singleshift.sg</p>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.section}>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <h4 className={classes.question}>How do I get paid?</h4>
                <div className={classes.answer}>
                  <p>SingleShift will pay you via bank transfer the following Monday.</p>
                </div>
              </div>
              <div className="col-md-6">
                <h4 className={classes.question}>What if I don’t show up for a shift?</h4>
                <div className={classes.answer}>
                  <p>Booking a shift is a commitment that SingleShift takes seriously. Not honoring your commitment might cause the business to be understaffed or worse. As a result, if you don’t show up for a shift, your account will be banned and any pay that hasn’t been paid out will be withheld.</p>
                  <p>Note: If you are working a multi-day shift and fail to turn up to any of the days, your wages for the entire shift will be withheld.</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h4 className={classes.question}>What if I need to cancel?</h4>
                <div className={classes.answer}>
                  <p>We understand things come up. If you cancel within 48 hours of the shift there’s no penalty. If you cancel within 24 hours of the shift, you will be de-prioritized for future shifts.</p>
                </div>
              </div>
              <div className="col-md-6">
                <h4 className={classes.question}>What if I have friends I want to work with?</h4>
                <div className={classes.answer}>
                  <p>A fair number of our shifts are looking for more than one person. Just ask!</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h4 className={classes.question}>What if the business wants to hire me after a shift?</h4>
                <div className={classes.answer}>
                  <p>Up to you! If you like working there and they like having you work there then SingleShift is happy to have brought you together :)</p>
                </div>
              </div>
              <div className="col-md-6">
                <h4 className={classes.question}>Can I set a preference for the location, type of business, etc. I’m interested in?</h4>
                <div className={classes.answer}>
                  <p>Not at the moment but hopefully soon!</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h4 className={classes.question}>Who is allowed to work on SingleShift?</h4>
                <div className={classes.answer}>
                  <p>We only accept people who are legally allowed to work in Singapore like Citizens, Permanent Residents and student’s on a Students Pass.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer/>

      </div>
    )
  }
}

const styles = (theme) => ({
  hero: {
    backgroundColor: '#004DAA',
  },
  headline: {
    margin: '60px 0',
    paddingBottom: '0 !important',
  },
  heroBtn: {
    marginBottom: '15px',
  },
  pageIdentifier: {
    marginBottom: '10px !important',
    fontSize: '18px !important',
    letterSpacing: '0.75px',
    fontWeight: '800',
  },
  section: {
    padding: '100px 0',
    borderBottom: '1px solid #efefef',
  },
  question: {
    fontSize: '18px',
    lineHeight: '1.666667',
    fontWeight: '800',
    marginBottom: '15px',
  },
  answer: {
    marginBottom: '60px',
  },
});

export default (withStyles(styles)(ProFaqPage));



// WEBPACK FOOTER //
// ./src/pages/ProFaqPage.js